// import { SWIPER } from '@namespace/top/swiper'
import { CLIPBOARD } from '@namespace/top/clipboard'

export default function top() {
  const body = document.querySelector('body')

  if (body.classList.contains('home')) {
    // SWIPER.init()
    CLIPBOARD.init()
  }
}
